export default __webpack_public_path__ + "static/media/keto_veggies@2x.c50651e1.jpg";